export const brands = [
  { name: 'JCB', cieloName: 'JCB', className: 'jcb', regex: /^35\d?/ },
  { name: 'Elo', cieloName: 'ELO', className: 'elo', regex: /^(5090|636|504|506)\d?/ },
  { name: 'Visa', cieloName: 'VISA', className: 'visa', regex: /^4\d{5}?/ },
  { name: 'Amex', cieloName: 'AMEX', className: 'amex', regex: /^(34|37)\d?/ },
  { name: 'Aura', cieloName: 'AURA', className: 'aura', regex: /^50\d{2}?/ },
  { name: 'Diners', cieloName: 'DINERS', className: 'diners', regex: /^(301|305|36\d{3}?|38)\d?/ },
  { name: 'Master',  cieloName: 'MASTERCARD', className: 'master', regex: /^5[1-5]\d?/ },
  { name: 'Discover', cieloName: 'DISCOVER', className: 'discover', regex: /^(6011|622|64|65)\d?/ },
];



// WEBPACK FOOTER //
// ./src/app/shared/services/cartao/brands.service.ts